module.exports = __webpack_public_path__ + "static/stacked-column-1395b341e7b5a2f538cd3bde368ed143.png";